// eslint-disable-next-line
export const LOCALE_PREFIX = 'scenes.Gnosus.components.Workspace.components.HocBlock.components.BlockTitle'
